import pkg from '../package.json';

export const REJECT_TIMEOUT    = 15000;
export const NAMESPACE         = 'vocento';
export const PROMISES_PROPERTY = '__PROMISES__';
export const EVENTS_PROPERTY   = '__EVENTS__'; // NOTE: unused
export const REQUIREJS_URL     = _isPhantomJS() ? 'vendors/require.js' : `//static.vocento.com/voonto/${pkg.version}/vendors/require.js`;
export const SHOW_LOGS         = document.location.search.indexOf('voonto_debug=1') > -1;
export const VOCUSER_COOKIE    = 'voc_uid';
export const PAYWALL_COOKIE    = 'voc_paywall';

/* Private */

function _isPhantomJS() {
  return document.location.protocol === 'file:';
}



// WEBPACK FOOTER //
// ./src/constants.js